// ofType :: t -> a -> Boolean
export const ofType = (type) => (action) => action.type === type;